import { ViewSupport42Container } from "../../../containers/SupportSystem/ViewReports/ViewSupport42Container"
export function ViewSupport42Page() {
    return (
        <ViewSupport42Container />
    )
}